import { Reducer } from '../types/state';

const exporter =
  <S>(initialState: S, handlers: Record<string, Reducer<S>>) =>
  // eslint-disable-next-line @typescript-eslint/default-param-last
  (state = initialState, action: any) =>
    action && handlers[action.type] ? handlers[action.type](state, action) : state;

export default exporter;
